<ng-container [formGroup]="formGroup">
  <dsd-address
    required="true"
    (dsdAddressReady)="onAddressReady($event)"
    (dsdAddressUpdated)="onAddressSelected($event)"
    [config]="configAdresse"
    variant="title"
  >
    <h3 class="dsd-t-4" slot="legend">{{ 'modifierAdresse.adresse.libelle' | translate }}</h3>
    <span slot="description">{{ 'modifierAdresse.description' | translate }}</span>
    <dsd-datepicker
      required
      [min]="dateMin"
      [max]="dateMax"
      [value]="formGroup.get('dateDebutUtilisation')?.value || ''"
      (dsdDatepickerChange)="onDateDebutUtilisation($event)"
    >
      <span slot="label">{{ 'modifierAdresse.adresse.dateChangement' | translate }}</span>
      <span slot="hint">{{ 'modifierAdresse.adresse.guidage' | translate }}</span>
      <span slot="error"> {{ 'modifierAdresse.erreur.dateInvalide' | translate }}</span>
    </dsd-datepicker>
  </dsd-address>
</ng-container>
